import type { TextStyles } from "@yamada-ui/core"

export const textStyles: TextStyles = {}
